import React, { createContext, useContext, useEffect, useState } from "react";
import { Hub } from "aws-amplify/utils";
import { getCurrentUser, fetchAuthSession, signOut as amplifySignOut } from "aws-amplify/auth";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function hydrate() {
    try {
      const cur = await getCurrentUser();
      const session = await fetchAuthSession();

      const email = session?.tokens?.idToken?.payload?.email || cur?.username;
      const name =
        session?.tokens?.idToken?.payload?.name ||
        email?.split("@")[0] ||
        cur?.username;

      setUser({ ...cur, email, name });
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    hydrate();
    const unsub = Hub.listen("auth", ({ payload }) => {
      if (["signedIn", "signedOut", "tokenRefresh"].includes(payload.event)) {
        hydrate();
      }
    });
    return () => unsub();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        signOut: () => amplifySignOut({ global: true }),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
